import { ShipmentDetails } from '@interfaces/models/timeline';
import { createContext, PropsWithChildren } from 'react';

export interface StepInfoContextProps {
  userType: string;
  // For Address Form
  isShowAddressForm: boolean;
  showAddressForm: (v: boolean) => void;
  // For Waiting ship item
  shipmentDetails?: ShipmentDetails;
}

// Create the context with default values
const StepInfoContext = createContext<StepInfoContextProps>({
  userType: '',
  // For Address Form
  isShowAddressForm: false,
  showAddressForm: () => {},
  // For Waiting ship item
  shipmentDetails: undefined,
});

interface StepInfoProviderProps extends StepInfoContextProps, PropsWithChildren {
  children: React.ReactNode;
}

const StepInfoProvider = ({
  children,
  isShowAddressForm,
  showAddressForm,
  userType,
  shipmentDetails,
}: StepInfoProviderProps) => {
  return (
    <StepInfoContext
      value={{
        userType,
        // For Address Form
        isShowAddressForm,
        showAddressForm,
        // For Waiting ship item
        shipmentDetails,
      }}
    >
      {children}
    </StepInfoContext>
  );
};

export { StepInfoContext, StepInfoProvider };
